import {
  CoworkingDayPassAvailabilityDto,
  LocationProductsDto,
  MeetingProductAvailabilityDto,
  ProductAvailabilityDto,
} from '@/lib/locations/dto/location-products.dto';

import { CHECKOUT_PRODUCTS } from './constants';

export function hasLocationProductsToDisplay(
  locationProducts: LocationProductsDto
) {
  const productNames = Object.keys(locationProducts) as Array<
    keyof LocationProductsDto
  >;
  const productsToDisplay = productNames.filter((productName) =>
    shouldDisplayProduct(locationProducts[productName])
  );

  return productsToDisplay.length > 0;
}

function hasDailyOnDemandCapacity(
  product:
    | ProductAvailabilityDto
    | CoworkingDayPassAvailabilityDto
    | MeetingProductAvailabilityDto
): product is CoworkingDayPassAvailabilityDto {
  return 'dailyOnDemandCapacity' in product;
}

export function shouldDisplayProduct(
  product:
    | ProductAvailabilityDto
    | CoworkingDayPassAvailabilityDto
    | MeetingProductAvailabilityDto
) {
  if (hasDailyOnDemandCapacity(product)) {
    return Boolean(
      product.availableAtLocation &&
        product.currentlySellable &&
        product.canBuyOnline &&
        product.dailyOnDemandCapacity != null &&
        product.dailyOnDemandCapacity > 0
    );
  }

  return product.availableAtLocation || product.currentlySellable;
}

export function canDisplayLearnMoreLink(params: {
  productName: keyof LocationProductsDto;
  currentlySellable: boolean;
  canBuyOnline?: boolean;
}) {
  const { canBuyOnline, currentlySellable, productName } = params;
  if (!CHECKOUT_PRODUCTS.includes(productName)) {
    return currentlySellable;
  }

  return currentlySellable && canBuyOnline;
}

export function isSuitesTheOnlyAvailableProduct(
  locationProducts: LocationProductsDto
) {
  const productNames = Object.keys(locationProducts) as Array<
    keyof LocationProductsDto
  >;
  const productsToDisplay = productNames.filter((productName) =>
    shouldDisplayProduct(locationProducts[productName])
  );

  return productsToDisplay.length === 1 && productsToDisplay[0] === 'suites';
}

export function shouldDisplayDedicatedOfficeOnlineProducts(
  product: ProductAvailabilityDto
) {
  return (
    !!product.availableAtLocation &&
    !!product.currentlySellable &&
    !!product.canBuyOnline
  );
}
